import React from "react";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import Menu from "../utils/Menu";

function AOBreadcrumb() {

    const items = Menu;

    const itemRender = (currentRoute, params, items, paths) => {
        const isLast = currentRoute?.path === items[items.length - 1]?.path;

        return isLast ? (
            <span>{currentRoute.title}</span>
        ) : (
            <Link to={`/${paths.join("/")}`}>{currentRoute.title}</Link>
        );
    }

    return (
        <Breadcrumb itemRender={itemRender} items={items} />
    );
}

export default AOBreadcrumb;
